import { UserActivitiesDuration } from "./UserActivitiesDuration";
import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const UserActivitiesDurations = z.object({
    durations: UserActivitiesDuration.array(),
});

export type UserActivitiesDurations = z.infer<typeof UserActivitiesDurations>;
